// RxJS
import { combineLatest } from 'rxjs';
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectPatientInsuranceInStore,
  selectPatientInsurancePageLoading,
  selectPatientInsuranceShowInitWaitingMessage,
} from '../_selectors/patient-insurance.selectors';

export class PatientInsuranceDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectPatientInsurancePageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectPatientInsuranceShowInitWaitingMessage),
    );

    combineLatest([
      this.store.pipe(select(selectPatientInsuranceInStore)),
      this.isPreloadTextViewed$,
    ]).subscribe(([response, showInitWaitingMessage]: [QueryResultsModel, boolean]) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
      // Initial store state is also empty. Wait until the request has finished
      // so "No records found" is not shown during the first load.
      if (!showInitWaitingMessage) {
        const total = response.totalCount ?? response.items?.length ?? 0;
        this.hasItems = total > 0;
      }
    });
  }
}
